import Swiper from 'swiper'
import { Navigation, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'

// ============================================
// HERO: BEIGE + SPINNER 1 SEC, THEN IMAGES → LOGO → ARROW (STAGGERED)
// ============================================
function initHeroReveal() {
    const hero = document.querySelector('[data-hero-slideshow]')
    const spinner = document.querySelector('[data-hero-spinner]')
    const logo = document.querySelector('[data-hero-logo]')
    const arrow = document.querySelector('[data-hero-arrow]')
    if (!hero) return

    setTimeout(() => {
        spinner?.classList.add('is-hidden')
        requestAnimationFrame(() => {
            hero.removeAttribute('style')
            hero.classList.add('is-loaded')
        })
        setTimeout(() => {
            logo?.removeAttribute('style')
            logo?.classList.add('is-visible')
        }, 1000)
        setTimeout(() => {
            arrow?.removeAttribute('style')
            arrow?.classList.add('is-visible')
        }, 2000)
    }, 1000)
}

// ============================================
// HERO SLIDESHOW WITH KEN BURNS EFFECT
// ============================================
function initHeroSlideshow() {
    const heroSlideshow = document.querySelector('[data-hero-slideshow]')
    if (!heroSlideshow) return

    const slides = heroSlideshow.querySelectorAll('.hero-slide')
    let currentSlide = 0
    const slideInterval = 5000

    function showNextSlide() {
        slides[currentSlide].classList.remove('active')
        currentSlide = (currentSlide + 1) % slides.length
        slides[currentSlide].classList.add('active')
    }

    setInterval(showNextSlide, slideInterval)
}

// ============================================
// GALLERY SWIPER + CIRCLE CUTOUT OVERLAY
// ============================================
function initGallerySwiper() {
    const swiperEl = document.querySelector('[data-gallery-swiper]')
    if (!swiperEl) return

    const prevButton = document.querySelector('[data-gallery-prev]')
    const nextButton = document.querySelector('[data-gallery-next]')
    const overlay = document.querySelector('[data-gallery-overlay]')
    const tapLayer = document.querySelector('[data-gallery-tap-to-expand]')

    let circleExpanded = false
    function expandCircle() {
        if (!overlay || circleExpanded) return
        circleExpanded = true
        overlay.classList.add('is-expanded')
        if (tapLayer) tapLayer.style.pointerEvents = 'none'
    }
    function collapseCircle() {
        if (!overlay || !circleExpanded) return
        circleExpanded = false
        overlay.classList.remove('is-expanded')
    }

    const swiper = new Swiper(swiperEl, {
        modules: [Navigation, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
        },
        on: {
            slideChangeTransitionStart: expandCircle,
        },
    })

    // Desktop: hover either arrow to hide the circle; leave arrow area to show it again
    function isDesktop() {
        return window.matchMedia('(min-width: 768px)').matches
    }
    function onArrowAreaLeft() {
        if (isDesktop()) collapseCircle()
    }
    if (prevButton) {
        prevButton.addEventListener('mouseenter', expandCircle)
        prevButton.addEventListener('mouseleave', function (e) {
            const to = e.relatedTarget
            if (!to || (!nextButton.contains(to) && to !== nextButton)) onArrowAreaLeft()
        })
    }
    if (nextButton) {
        nextButton.addEventListener('mouseenter', expandCircle)
        nextButton.addEventListener('mouseleave', function (e) {
            const to = e.relatedTarget
            if (!to || (!prevButton.contains(to) && to !== prevButton)) onArrowAreaLeft()
        })
    }

    // Mobile: invisible tap layer covers gallery; first tap anywhere hides circle and then layer gets out of the way
    if (tapLayer) {
        tapLayer.addEventListener('touchstart', expandCircle, { passive: true })
        tapLayer.addEventListener('click', expandCircle)
    }

    // Add click handlers for expanding gallery
    const imageContainers = document.querySelectorAll('.gallery-image-container')
    imageContainers.forEach(container => {
        container.addEventListener('click', function() {
            this.classList.toggle('expanded')
        })
    })
}

// ============================================
// VIMEO VIDEO – background loop until play clicked, then play with sound
// ============================================
function initVimeoVideo() {
    const videoSection = document.querySelector('[data-video-section]')
    if (!videoSection) return

    const vimeoId = videoSection.getAttribute('data-vimeo-id')
    const playButton = document.querySelector('[data-video-play]')
    const overlay = document.querySelector('[data-video-play-overlay]')
    const backgroundIframe = document.querySelector('[data-vimeo-background]')

    if (!vimeoId || !playButton || !overlay || !backgroundIframe) return

    const foregroundUrl = `https://player.vimeo.com/video/${vimeoId}?badge=0&autoplay=1&controls=1&muted=0`

    playButton.addEventListener('click', function () {
        backgroundIframe.src = foregroundUrl
        videoSection.classList.add('is-playing')
        overlay.setAttribute('aria-hidden', 'true')
    })
}

// ============================================
// SCROLL REVEAL: SLIDE UP WHEN IN VIEW
// ============================================
function initScrollReveal() {
    const els = document.querySelectorAll('[data-animate-on-scroll]')
    if (!els.length) return

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible')
                }
            })
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0 }
    )

    els.forEach((el) => observer.observe(el))
}

// ============================================
// HERO SCROLL-DOWN ARROW
// ============================================
function initHeroScrollDown() {
    const hero = document.querySelector('[data-hero-slideshow]')
    const scrollDownBtn = document.querySelector('[data-scroll-down]')
    if (!hero || !scrollDownBtn) return

    scrollDownBtn.addEventListener('click', function (e) {
        e.preventDefault()
        let next = hero.nextElementSibling
        while (next && next.offsetParent === null) {
            next = next.nextElementSibling
        }
        if (!next) return
        const top = next.getBoundingClientRect().top + window.pageYOffset
        window.scrollTo({ top, behavior: 'smooth' })
    })
}

// ============================================
// INITIALIZE ALL ON DOM READY
// ============================================
document.addEventListener('DOMContentLoaded', function() {
    initHeroReveal()
    initHeroSlideshow()
    initGallerySwiper()
    initVimeoVideo()
    initHeroScrollDown()
    initScrollReveal()
})
